import * as Sentry from '@sentry/react';

interface Metadata {
    [key: string]: string;
}

type ContextType = Record<string, any>;

function logEventToConsole({
    message,
    tags = {},
    contexts = {},
    level,
}: {
    message: string;
    tags: Metadata;
    contexts: ContextType;
    level: 'error' | 'warning' | 'info';
}) {
    console.group(message);
    console.info(tags);
    console.info(contexts);
    console.groupEnd();
}

function logEvent({
    message,
    tags = {},
    contexts = {},
    level = 'error',
    slackChannel,
}: {
    message: string;
    tags: Metadata;
    contexts: ContextType;
    level: 'error' | 'warning' | 'info';
    slackChannel?: string;
}) {
    logEventToConsole({
        message,
        tags,
        contexts,
        level,
    });

    // Une info n'est pas un bug : elle accompagne le prochain event au lieu d'ouvrir une issue.
    if (level === 'info') {
        Sentry.addBreadcrumb({ level, message, data: { ...tags, ...contexts } });
        return;
    }

    Sentry.captureEvent({
        level,
        message,
        tags,
        contexts,
    });
}

export function logError({
    message,
    tags = {},
    contexts = {},
    slackChannel,
}: {
    message: string;
    tags?: Metadata;
    contexts?: ContextType;
    slackChannel?: string;
}) {
    return logEvent({ message, tags, contexts, slackChannel, level: 'error' });
}

export function logWarning({
    message,
    tags = {},
    contexts = {},
    slackChannel,
}: {
    message: string;
    tags?: Metadata;
    contexts?: ContextType;
    slackChannel?: string;
}) {
    return logEvent({ message, tags, contexts, slackChannel, level: 'warning' });
}

export function logInfo({
    message,
    tags = {},
    contexts = {},
    slackChannel,
}: {
    message: string;
    tags?: Metadata;
    contexts?: ContextType;
    slackChannel?: string;
}) {
    return logEvent({ message, tags, contexts, slackChannel, level: 'info' });
}
